var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"tile":"","min-height":"500"}},[_c('div',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.$t('ManagePrivileges'))+" ")]),_c('v-card-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }